import { Icon } from '@iconify/react';
import React from 'react';
import { Link } from 'react-router-dom';

export default function SocialWidget() {
  return (
    <div className="cs_social_links_wrap">
      <h2>Follow Us</h2>
      <div className="cs_social_links">
        <Link to="https://www.facebook.com/StarBrightAppliedBehaviorAnalystPLLC" target="_blank">
          <Icon icon="fa-brands:facebook-f" />
        </Link>
        <Link to="https://www.instagram.com/starbrightaba/" target="_blank">
          <Icon icon="fa7-brands:instagram" />
        </Link>
      </div>
      
    </div>
  );
}
